import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../pagescss/available.css";
import refresh from "../assets/refresh.png";
import { API_URL } from "./apiConfig";

const AvailableGames = () => {
  const [availableGames, setAvailableGames] = useState([]); // Always initialized as an array
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  //
  //

  const handleJoin = async (gameId) => {
    // const player2Id = JSON.parse(localStorage.getItem("user"))?.id;
    const player2Id = JSON.parse(localStorage.getItem("no-msisdn"));

    if (!player2Id) {
      console.error("Player 2 ID not found in localStorage");
      return;
    }

    try {
      const response = await fetch(
        `${API_URL}/api/games/join/${gameId}/${player2Id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem("gameId", gameId);

        console.log("Player 2 has joined the game successfully", data);
        // Navigate to the game board and wait for player 2

        // Redirect to game page or handle as needed
        navigate(`/game/${gameId}`);
      } else {
        console.error("Failed to join game:", data.message);
      }
    } catch (error) {
      console.error("Error joining game:", error);
    }
  };

  const fetchAvailableGames = async () => {
    try {
      const response = await fetch(`${API_URL}/api/games/available`);
      const data = await response.json();

      if (response.ok) {
        setAvailableGames(data.availableGames || []); // Ensure it's an array
      } else {
        setError(data.message || "Failed to fetch available games");
      }
    } catch (error) {
      setError("Server error, please try again later");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAvailableGames();
  }, []);

  return (
    <div className="available-games-container">
      {loading ? (
        <p className="loading">Loading games...</p>
      ) : error ? (
        <p className="error-message">{error}</p>
      ) : availableGames.length === 0 ? (
        <p className="no-game">
          <button onClick={fetchAvailableGames} className="join-game-button">
            <img src={refresh} alt="refresh-icon" style={{ width: "40px" }} />
          </button>
          <h2 style={{ fontSize: "15px" }}>
            {" "}
            No available games found. Create a game or play with PC
          </h2>
        </p>
      ) : (
        <div className="games-list">
          {availableGames.map((game) => (
            <div key={game.game_id} className="game-item">
              <div>
                <span className="Status-heading">Status</span>
                <p className="Status-text">{game.game_status}</p>
              </div>
              <button
                onClick={() => handleJoin(game.game_id)}
                className="join-game-button"
              >
                Join Game
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AvailableGames;
